import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-unescaped-entities */
import { Box, Typography, Tooltip } from '@mui/material';
import SeniorDetail from 'pages/WCPages/SeniorDashboard/components/SeniorDetails/SeniorDetail.component';
import ResidentDetailSummary from '../AllResidents/component/ResidentDetailSummary/ResidentDetailSummary';
// import {useQuery} from 'utilities/react-query';
// import {IGetFacilityGraphServiceParams} from 'services/facilityGraphServices/facilityGraphServices.types';
// import {getActivityGraphService} from 'services/facilityGraphServices/activityGraphService/activityGraph.service';
// import {IActivityGraphParse} from 'services/facilityGraphServices/activityGraphService/parser/activityGraphParser';
import { useAppSelector } from 'hooks/reduxHooks';
// import {showError} from 'store/commonReducer/common.action';
import React from 'react';
// import {IActivityGraphData} from 'services/facilityGraphServices/activityGraphService/activityGraphService.types';
// import {
//   IZoneGraphRecord,
//   getActivityChartTickValues,
//   getScoreAndTarget,
// } from '../FacilityDashboard/component/ZoneChart/ZoneChart.types';
// import {MONTHS} from 'globals/global.constants';
// import {IInitialZoneState} from '../FacilityDashboard/component/Filters/Filters.types';
// import ZoneChart from '../FacilityDashboard/component/ZoneChart/ZoneChart.component';
import GoalPercentage from './components/GoalPercentage/GoalPercentage';
import FacilitySummaryTable from './components/FacilitySummaryTable/FacilitySummaryTable.component';
import { residentDashboardStyle } from './ResidentDashboard.style';
import EmotionalSurveyCard from './components/EmotionalSurveyCard/EmotionalSurveyCard.component';
// import UCLALonelinessAssessment from './components/UCLALonelinessAssessment/UCLALonelinessAssessment';
import InfoIcon from '@mui/icons-material/Info';
// eslint-disable-next-line max-len
// import FallsAndHospitalizationAssessment from './components/FallsAndHospitalizationAssessment/FallsAndHospitalizationAssessment';
// import { getClientTimezone } from 'globals/date.functions';
// import { getTimeStamp } from 'globals/global.functions';
// import HomeSafetyAssessment from './components/HomeSafetyAssessment/HomeSafetyAssessment';
var IndependentLivingResidentDashboard = function () {
    var classes = residentDashboardStyle().classes;
    var seniorDetail = useAppSelector(function (state) { return state.common; }).seniorDetail;
    var minimalInfo = seniorDetail.minimalInfo;
    var careInsightHistory = useAppSelector(function (state) { return state.seniorDashboard.careInsightHistory.data; });
    var careInsightHistoryLoading = useAppSelector(function (state) { return state.seniorDashboard.careInsightHistory.loading; });
    // const zone = React.useMemo(() => {
    //   return minimalInfo?.zone?.toLowerCase() || '';
    // }, [minimalInfo?.zone]);
    // const zones = React.useMemo<IInitialZoneState>(
    //   () => ({
    //     overall: true,
    //     blue: false,
    //     green: false,
    //     gold: false,
    //   }),
    //   [],
    // );
    // const dispatch: any = useAppDispatch();
    var facilityType = React.useMemo(function () {
        return minimalInfo.facility_type
            .split(' ')
            .map(function (x) {
            if (x === void 0) { x = ''; }
            return x.toLowerCase();
        })
            .join('_');
    }, [minimalInfo.facility_type]);
    if (facilityType === 'home_care') {
        facilityType = 'memory_care';
    }
    //activity graph query
    // const {data: activityGraphDatum, isLoading: isActivityGraphLoading} = useQuery(
    //   {
    //     queryKey: ['facilityActivityGraph'],
    //     queryFn: async (): Promise<any> => {
    //       const apiParams: IGetFacilityGraphServiceParams = {
    //         duration: 3,
    //         facility_type: facilityType,
    //         senior_id: minimalInfo.user_id,
    //         zone,
    //         timezone: getClientTimezone(),
    //         ...getTimeStamp(3)
    //       };
    //       const data: IActivityGraphParse = await getActivityGraphService(
    //         apiParams,
    //       );
    //       return data;
    //     },
    //     onError: (error: any) => {
    //       dispatch(showError(error));
    //     },
    //     cacheTime: 0,
    //     enabled: !!facilityType,
    //   },
    // );
    // const activityGraphData = activityGraphDatum?.parsedResponse;
    // /**
    //  * @description function to convert activityData to Graph Data
    //  * @function getGraphDataFromActivityGraphData
    //  * @param {IActivityGraphData[]} zoneData
    //  * @returns {IZoneGraphRecord[]} graphData
    //  */
    // const getGraphDataFromActivityGraphData = React.useCallback(
    //   (zoneData: IActivityGraphData[] = []): IZoneGraphRecord[] => {
    //     const graphData = zoneData?.map(({timestamp, score}) => {
    //       const d = new Date(timestamp);
    //       return {
    //         x: MONTHS[d.getMonth()],
    //         y: score || 0,
    //       };
    //     });
    //     return graphData || [];
    //   },
    //   [],
    // );
    // const activityData = React.useMemo(() => {
    //   return {
    //     overall: getGraphDataFromActivityGraphData(
    //       activityGraphData?.[zone]?.data,
    //     ),
    //     blue: getGraphDataFromActivityGraphData([]),
    //     green: getGraphDataFromActivityGraphData([]),
    //     gold: getGraphDataFromActivityGraphData([]),
    //   };
    // }, [activityGraphData, zone]);
    // const {activity: activityScore, target: activityTarget} = React.useMemo(() => {
    //   return getScoreAndTarget(zones, activityGraphData);
    // }, [activityGraphData, zones]);
    // const activityTickValues = React.useMemo(() => {
    //   return getActivityChartTickValues(activityData, activityTarget, 10000);
    // }, [activityData, activityTarget]);
    var summaryData = React.useMemo(function () {
        return careInsightHistory ? careInsightHistory.slice(0, 20) : [];
    }, [careInsightHistory]);
    // const tooltipText = (
    //   <React.Fragment>
    //     <Typography variant='h3' component='div' sx={{fontWeight: 'bold'}}>
    //       Understanding Average Activity Trends
    //     </Typography>
    //     <Typography component='div'>
    //       Activity data, sourced from ClearWellness smartwatches allocated to clients
    //       at program commencement, is calculated using a proprietary point system.
    //       This system encourages older adults to strive for a daily minimum of
    //       40,000 points. Personalized goals are then collaboratively established
    //       by the ClearWellness care team to facilitate clients in achieving their
    //       desired scores effectively.
    //     </Typography>
    //   </React.Fragment>
    // );
    var tooltipText2 = (_jsxs(React.Fragment, { children: [_jsx(Typography, { variant: 'h3', component: 'div', sx: { fontWeight: 'bold' }, children: "Weekly Wellness Updates" }), _jsx(Typography, { component: 'div', children: "Wellness coaches send weekly messages to provide progress updates on clients' well-being, assistance requirements, and caregiver concerns. This regular communication ensures all parties stay informed and enables tailored support and care for clients throughout their journey." })] }));
    return (_jsxs(Box, { display: 'flex', margin: '24px', gap: '24px', children: [_jsx(Box, { display: 'flex', flexDirection: 'column', width: '397px', minWidth: '397px', maxWidth: '397px', gap: '24px', children: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: '16px', children: [_jsx(SeniorDetail, { isResident: true }), _jsx(ResidentDetailSummary, {})] }) }), _jsx(Box, { display: 'flex', flexDirection: 'column', width: '397px', minWidth: '397px', maxWidth: '397px', gap: '24px', children: _jsx(GoalPercentage, {}) }), _jsxs(Box, { display: 'flex', flexDirection: 'column', flexGrow: 1, minWidth: '480px', gap: '24px', children: [_jsx(Box, { children: _jsxs(Box, { className: classes.card, children: [_jsxs(Box, { padding: '12px 20px', style: { display: 'flex' }, children: [_jsx(Typography, { component: "div", variant: 'h2', color: 'WindowText', children: "Messages" }), _jsx(Tooltip, { title: tooltipText2, children: _jsx(Box, { children: _jsx(InfoIcon, { style: { marginLeft: '318px', position: "relative", top: "5px" }, fontSize: 'medium' }) }) })] }), _jsx(FacilitySummaryTable, { data: summaryData || [], loading: careInsightHistoryLoading, height: '360px' })] }) }), _jsx(Box, { children: _jsx(EmotionalSurveyCard, {}) })] })] }));
};
export default IndependentLivingResidentDashboard;
